export default function Stats({ items }) {
  if (!items.length)
    return (
      <footer className="stats">
        <em>Start adding items for your trip! 🚀</em>
      </footer>
    );

  // Example of derived states 👇
  const numItems = items.length;
  const numPackedItems = items.filter((item) => item.packed).length;
  const percentage = Math.round((numPackedItems / numItems) * 100);
  // Example of derived states 👆
  return (
    <footer className="stats">
      <em>
        {percentage === 100
          ? "You got everything ready for your trip ✈️"
          : `You have ${numItems} items in your list, and you already packed
      ${numPackedItems} (${percentage}%)`}
      </em>
    </footer>
  );
}
